import * as React from "react";
export default function Aviso() {
  return <section id="aviso" className="w-full bg-muted pt-12 pb-32 px-4 md:px-8">
      <div className="max-w-7xl mx-auto">
        <h4 className="text-lg font-semibold font-default text-foreground mb-4">
          Información importante sobre tu trámite
        </h4>
        <div className="text-sm font-sans text-muted-foreground leading-relaxed space-y-4 max-w-4xl">
          <p>
            La información de este sitio es orientativa y puede variar según el tipo de documento, la entidad emisora y el país donde será presentado. Antes de iniciar, revisamos tu caso para orientarte con claridad sobre requisitos, tiempos estimados y el siguiente paso.
          </p>
        </div>
      </div>
    </section>;
}